export const supplierOperationsGettingStartedArticle = {
  title: 'Supplier Operations Hub: Getting Started',
  slug: 'supplier-operations-getting-started',
  content: `Supplier Operations Hub: Getting Started

Manage suppliers, quotes, inventory, and analytics from one hub.

1) Open the supplier hub
- Go to /supplier-hub.
- Tabs use URL hashes (for example #suppliers).

2) Discover suppliers
- Discover helps you research and source new suppliers.

3) Manage suppliers & contacts
- Suppliers and Contacts tabs hold supplier profiles and people.

4) Track quotes and inventory
- Quotes log pricing requests and negotiations.
- Inventory tracks available stock and records.

5) Review analytics
- Analytics summarizes supplier activity.

Tips
- Use Cmd/Ctrl + K to open the command palette.
`,
};
